import React from 'react';
import { Question } from 'types/questionnaire/types';

interface ConfirmationCheckboxQuestionProps {
  question: Question;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  onAdvance: () => void;
  error?: string;
}

const ConfirmationCheckboxQuestion: React.FC<ConfirmationCheckboxQuestionProps> = ({
  question,
  value,
  onChange,
  onAdvance,
  error,
}) => {
  const buttonLabel = question.submitLabel || 'Continue';
  return (
    <div className="flex flex-col gap-2">
      <label className="flex items-center gap-2 text-lg font-semibold leading-7 tracking-tight text-brand-black">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
        <span>
          {question.text}
          {question.required ? ' *' : ''}
        </span>
      </label>
      {question.description && <p className="text-sm text-brand-black/80">{question.description}</p>}
      <button
        type="button"
        className={`w-fit rounded-lg border px-4 py-2 text-sm font-semibold ${
          value
            ? 'border-talo-dark-green bg-talo-dark-green text-white'
            : 'border-gray-300 bg-gray-100 text-brand-black/50 cursor-not-allowed'
        }`}
        onClick={() => {
          if (value) onAdvance();
        }}
        disabled={!value}
      >
        {buttonLabel}
      </button>
      {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
    </div>
  );
};

export default ConfirmationCheckboxQuestion;
